import React from "react";

import { Icon } from "@livingmap/hippo";
import styles from "./Tag.module.scss";

interface Props {
  dataQA: string;
  text: string;
  onClick: () => void;
}

const Tag: React.FC<Props> = ({ dataQA, text, onClick }) => {
  return (
    <div data-qa={dataQA} className={styles.container}>
      <span className={styles.text}>{text}</span>
      <button className={styles.button} onClick={onClick}>
        <Icon dataQA="clear-icon" name="clear" size={18} />
      </button>
    </div>
  );
};

export default Tag;
